var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-card"},[_c('v-arrow-bg',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("能源统计")]},proxy:true}])},[_c('div',{staticClass:"v-card-container"},[_c('mr-echarts',{attrs:{"options":_vm.options}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }